// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link_1koDm","spinAround":"Link_spinAround_1ilf0"};